import React from "react";
import CustomModal from "../../../Core/Common/CustomModal";
import CustomButton from "../../../Core/Common/CustomButton";
import { useAppDispatch, useAppSelector } from "../../../Core/redux/hooks";
import {
  createGoal,
  getGoalsBySprint,
  updateGoal,
  updateProgress,
} from "../../../Core/redux/api/scheduleAPI";
import { useParams } from "react-router-dom";
import { resetSchedule } from "../../../Core/redux/slices/schedule.slice";

type DuplicateTaskModalProps = {
  visible: boolean;
  onCancel: () => void;
  //onOk: () => void;
};

const DuplicateTaskModal = ({ visible, onCancel }: DuplicateTaskModalProps) => {
  const { duplicateTaskModal } = useAppSelector((state) => state.schedule);

  const getStatus = (statusId) => {
    switch (statusId) {
      case 1:
        return (
          <div className="w-[60px] bg-gray-100 rounded-2xl">
            <p className="text-gray-700 uppercase whitespace-nowrap px-2">
              To do
            </p>
          </div>
        );
      case 2:
        return (
          <div className="w-[115px] bg-primary-600 rounded-2xl">
            <p className="text-white uppercase whitespace-nowrap px-2">
              In progress
            </p>
          </div>
        );
      case 3:
        return (
          <div className="w-[60px] bg-success-600 rounded-2xl">
            <p className="text-white uppercase whitespace-nowrap px-2">Done</p>
          </div>
        );
      default:
        return (
          <div className="w-[56px] bg-gray-100 rounded-2xl">
            <p className="text-gray-700 uppercase whitespace-nowrap px-2 py-0.5 ">
              To do
            </p>
          </div>
        );
    }
  };

  const dispatch = useAppDispatch();
  const { selectedSprint, currentSelectedPhase } = useAppSelector(
    (state) => state.schedule
  );
  const { projectId } = useParams();

  const onSubmit = () => {
    const payload = {
      sprintId: selectedSprint.id,
      projectId: projectId,
      phaseId: duplicateTaskModal.duplicateTaskDetails.phaseId,
      names: [duplicateTaskModal.duplicateTaskDetails.name],
      isCompleted: 0,
      isNewGoal: Number(duplicateTaskModal.duplicateTaskDetails.isNewScope),
      statusId: duplicateTaskModal.duplicateTaskDetails.statusId,
      priorityId: duplicateTaskModal.duplicateTaskDetails.priorityId,
      goalType: duplicateTaskModal.duplicateTaskDetails.goalType,
      assigneeId: duplicateTaskModal.duplicateTaskDetails.assigneeId,
      reporterId: duplicateTaskModal.duplicateTaskDetails.reporterId,
      description: duplicateTaskModal.duplicateTaskDetails.description,
      estimatedTime: duplicateTaskModal.duplicateTaskDetails.estimatedTime,
      timeLogged: duplicateTaskModal.duplicateTaskDetails.timeLogged,
      componentId: duplicateTaskModal.duplicateTaskDetails.componentId,
      componentName: duplicateTaskModal.duplicateTaskDetails.componentName,
      categoryId: duplicateTaskModal.duplicateTaskDetails.categoryId,
      attachments: JSON.stringify(
        duplicateTaskModal.duplicateTaskDetails.attachments
      ),
    };
    dispatch(createGoal(payload));
    onCancel();
    dispatch(resetSchedule(["newTaskModal"]));
    dispatch(getGoalsBySprint({ projectId, sprintId: selectedSprint.id }));
    dispatch(
      updateProgress({
        phaseId: currentSelectedPhase.id,
        projectId,
      })
    );
  };

  return (
    <CustomModal
      title={<p className="mon-500-16 text-gray-700">Duplicate task</p>}
      width={"524px"}
      visible={visible}
      body={
        <div className="max-h-[38.189386056191466vh] overflow-y-scroll pt-6 px-5">
          <p className="mon-400-14 text-gray-500 ">
            Do you want to duplicate this task -{" "}
            <span className="font-[700]">
              {duplicateTaskModal.duplicateTaskDetails?.name}
            </span>
          </p>
        </div>
      }
      footer={
        <div className="flex justify-between pt-8 pb-4 px-3">
          <CustomButton
            text="Cancel"
            onClick={onCancel}
            className="border-2 border-gray-200 text-black bg-white mon-500-16 "
            height="44px"
            width="49%"
          />
          <CustomButton
            text="Duplicate task"
            onClick={onSubmit}
            className="mon-500-16 text-white  bg-primary-600 "
            height="44px"
            width="49%"
          />
        </div>
      }
      onCancel={onCancel}
    />
  );
};

export default DuplicateTaskModal;
